import { RevisionPlanRow } from 'components/tables/data/revision-plan/types';
import P2Regular from 'components/typography/P2Regular';

/**
 * Column for the manufacturer.
 */
export default function ManufacturerColumn({ data: { device } }: { data: RevisionPlanRow }) {
  return (
    <P2Regular color="gray.8" lineClamp={3}>
      {device.manufacturer}
    </P2Regular>
  );
}
